import type { ZodError } from "zod";
import { AppError } from "@/domain/errors/AppError";

/**
 * The backend answered 2xx but the payload does not match the OpenAPI spec
 * the SDK was generated from. This is never a user error — it means backend
 * and frontend disagree about the contract and the spec (or the backend)
 * needs fixing.
 */
export class ContractViolationError extends AppError {
  readonly isOperational = false;
  readonly code = "CONTRACT_VIOLATION";
  public readonly endpoint?: string;
  public readonly method?: string;
  public readonly zodError: ZodError;

  constructor(zodError: ZodError, endpoint?: string, method?: string) {
    super(
      endpoint
        ? `${method || "GET"} ${endpoint}: response does not match the OpenAPI contract`
        : "Response does not match the OpenAPI contract",
    );
    this.name = "ContractViolationError";
    this.zodError = zodError;
    this.endpoint = endpoint;
    this.method = method;
  }
}
